export const debounce = (fn, timeoutMs) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            fn(...args);
        }, timeoutMs);
    };
};
//# sourceMappingURL=debounce.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
